/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other
// files present in this directory. You're encouraged to place your
// actual application logic in a relevant structure within
// app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %>
// to the appropriate layout file, like
// app/views/layouts/application.html.erb

// Import jQuery first and expose it globally before any plugins load
import $ from 'jquery'

// Must be imported before bootstrap. Its capture-phase listener has to be
// registered first so a click on the organization switcher can insert
// #main_modal before Bootstrap's modal Data API reads it.
import '../javascripts/main-modal'

// Import only the Bootstrap components we use so webpack can tree-shake better
import { Collapse, Dropdown, Modal, Offcanvas, Tab, Tooltip } from 'bootstrap'
import 'bootstrap-datepicker'
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.de.min'
import '../javascripts/datepicker'
import 'jquery-ui/ui/widgets/sortable'
import '@nathanvda/cocoon'
import '../vendor/javascripts/recurring-select.js'

import '../javascripts/turbo-settings' // needs to be first
import '../javascripts/cascade-select'
import '../javascripts/theme-switcher'
import '../javascripts/direct_uploads'
import '../javascripts/lightbox'
import '../javascripts/pagination'
import '../javascripts/select_location'
import '../javascripts/slider'
import '../javascripts/static_document'

import '../javascripts/common'
import '../javascripts/webauthn'

import '../javascripts/controllers/contact_persons'
import '../javascripts/controllers/inspections'
import '../javascripts/controllers/inspection_settings'
import '../javascripts/controllers/notices'
import '../javascripts/controllers/maintenance_templates'
import '../javascripts/controllers/maintenance_records'
import '../javascripts/controllers/qr_codes'
import '../javascripts/controllers/reports'
import '../javascripts/controllers/reports_schedules'
import '../javascripts/controllers/roles'
import '../javascripts/controllers/tickets'
import '../javascripts/controllers/ticket_workflow'
import '../javascripts/controllers/time_trackings'
import '../javascripts/tom-select'

const bootstrap = {
  Collapse,
  Dropdown,
  Modal,
  Offcanvas,
  Tab,
  Tooltip
}

global.jQuery = $
global.$ = $
global.bootstrap = bootstrap
